module.exports = __webpack_public_path__ + "static/about-me-anita-b965c16a4b074e11dcae5789afe7de29.jpeg";